import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=6997f5d9&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=6997f5d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6997f5d9",
  null
  
)

export default component.exports